import React from "react";
import { Box, Table, TableHead, TableBody, TableRow, TableCell } from "@mui/material";
import MemberDetailsRow from "./MemberDetailsRow";

const MemberDetailsTable = ({ details, isMeView = false }) => (
    <Box sx={{
        background: '#fff',
        boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
        border: '1px solid rgba(0, 0, 0, 0.1)',
        borderTop: 'none',
        marginTop: '-5px',
        padding: '10px',
        borderRadius: '0 0 10px 10px'
    }}>
        <Table size="small" sx={{ borderCollapse: 'separate', borderSpacing: '0 0px' }}>
            <TableHead sx={{ backgroundColor: '#fff' }}>
                <TableRow>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', minWidth: '32px', maxWidth: '32px', borderTopLeftRadius: '10px', borderBottomLeftRadius: '10px' }}>#</TableCell>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'start' }}>Date</TableCell>
                    {!isMeView && ( <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'left' }}>Member</TableCell>)}
                    <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'center' }}>Time</TableCell>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'left' }}>Activity</TableCell>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'center' }}>Manual hours</TableCell>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'center' }}>Idle (%)</TableCell>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', color: '#626262', textAlign: 'center' }}>Total spent</TableCell>
                    <TableCell sx={{ padding: '10px 16px', border: 'none', borderTopRightRadius: '10px', borderBottomRightRadius: '10px', textAlign: 'center' }}>Notes</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {details.map((detail, i) => (
                    <MemberDetailsRow key={i} detail={detail} index={i} rowDetails={details} isMeView={isMeView} />
                ))}
            </TableBody>
        </Table>
    </Box>
);

export default MemberDetailsTable;